import React from 'react';
import { FMessage } from '../../hoc/IntlComponents';

const WarningBlock = ({ id }) => {
  return (
    <div className="warning-wrapper">
      <b><FMessage id='transfer-by-api.warning.post-office.p-1' /></b>&nbsp;
      <FMessage id={id ? id : 'transfer-by-api.warning.post-office.p-2'} />
    </div>
  );
};

export default WarningBlock;
